import { render, staticRenderFns } from "./QueueSlot.vue?vue&type=template&id=4e964354&scoped=true&"
import script from "./QueueSlot.vue?vue&type=script&lang=js&"
export * from "./QueueSlot.vue?vue&type=script&lang=js&"
import style0 from "./QueueSlot.vue?vue&type=style&index=0&id=4e964354&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e964354",
  null
  
)

export default component.exports